import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { selectAreFontsReady } from '@ff-os/pdp-shared-redux/slices/fontsSlice';
import { selectLanguage } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { PaintablesRenderer } from '@ff-os/shared-react/components/paintables-renderer/PaintablesRenderer';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { toPaintableWithoutCropping } from '@ff-scene-plugins/photo-prints-shared/toPaintable';
import { Paintable } from 'ff-canvas';
import { selectFilledPhotoByIdWithoutBorders, selectSpaces } from '../../../_redux-photos';

const _PhotoPrintCropPreview = ({ paintables, language, fontsReady, spaces }: Props) => {
    return (
        <PaintablesRenderer
            fontsReady={fontsReady}
            paintables={paintables}
            language={language}
            spaces={spaces} />
    );
};

type OwnProps = {
    photoId: string;
};

type Props = OwnProps & {
    fontsReady: boolean;
    language: string;
    spaces: Spaces;
    paintables: Paintable[];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    fontsReady: selectAreFontsReady(state),
    language: selectLanguage(state),
    paintables: selectPaintablesWithoutBorders(state, ownProps.photoId),
    spaces: selectPhotoSpaces(state, ownProps.photoId)
});

export const PhotoPrintCropPreview = connect(mapStateToProps)(_PhotoPrintCropPreview);

const selectPhotoSize = createSelector([
    selectFilledPhotoByIdWithoutBorders
], photo => {

    if (!photo) {
        return { width: 0, height: 0 };
    };

    return {
        width: photo.width,
        height: photo.height
    };
});

const selectPhotoSpaces = createSelector([
    selectSpaces,
    selectPhotoSize
], (spaces, size) => ({
    ...spaces,
    sceneWidth: size.width,
    sceneHeight: size.height
}));

const selectPaintablesWithoutBorders = createSelector([
    selectFilledPhotoByIdWithoutBorders,
    selectPhotoSize,
    (state: PhotoPrintsPdpState) => state.auth.jwt
], (photo, size, jwt) => {

    if (!photo) {
        return [];
    };

    return [toPaintableWithoutCropping(photo, size, jwt)];
});